import { createGlobalStyle } from 'styled-components';

import { fontFamily, getBodyColor, getColorPrimary, mediaQueries } from '../libs';

const GlobalStyle = createGlobalStyle`
html {
  box-sizing: border-box;
  font-size: 14px;
  height: 100vh;
  overflow-x: hidden;

  input:-webkit-autofill,
  input:-webkit-autofill:hover, 
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
  -webkit-text-fill-color: #444 !important;
  box-shadow: 0 0 0px 1000px ${getColorPrimary}10 inset !important;
  transition: background-color 5000s ease-in-out 0s !important;
  }
}


::selection {
  background: ${getColorPrimary};
  color: #fff
}

*,
*:before,
*:after {
  box-sizing: inherit;
  outline: none;
  font-family:${fontFamily};
}

body {
  font-family: "Inter", sans-serif;
  margin: 0;
  min-height: 100%;
  background:${getBodyColor} !important;
}

a {
  text-decoration: none;
  color: inherit;
  cursor: pointer;
}

ol,
ul {
  list-style: none;
  padding: 8px 0;
  margin: 0;
}

img {
  border: 0;
  max-width:100%;
  vertical-align: middle;
  outline: none;
}

input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0; 
}

input[type=number] {
    -moz-appearance:textfield;
}

input[type="file"]::-webkit-file-upload-button {
  display: none;
}

#__next {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
} 

.rocketchat-widget {
  z-index: 10 !important;
}

@media (max-width: ${mediaQueries.smDefault}px) {
  .rocketchat-widget {
    bottom: 44.5px !important;
    right: -10px !important;
    max-height: calc(93vh - 45px) !important;
  }
}

 .ra-widget-reputation-holder {
   background: transparent !important;
 }

 .ra-widget-reputation-content {
   border: none !important;
 }

`;

export default GlobalStyle;
